import { Component, Input, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CustomButtonComponent } from '../custom-button/custom-button.component';
import { MatDrawer } from '@angular/material/sidenav';

@Component({
  selector: 'app-notification-drawer',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, CustomButtonComponent],
  templateUrl: './notification-drawer.component.html',
  styleUrl: './notification-drawer.component.scss',
})
export class NotificationDrawerComponent {
  public ELEMENT_IDS = ELEMENT_IDS;
  @Input() drawerRef!: MatDrawer;

  closeDrawer() {
    this.drawerRef.close();
  }

  mockData = [
    {
      summaryTitle: 'Supplier Deliveries',
      summaryCountTitle: 'No. of DRs',
      url: 'wms-report-receiving',
      isViewable: 1,
      isConsolidated: true,
      icon: 'local_shipping',
      items: [
        {
          label: 'EDA is Today',
          noOfDr: 20,
          filters: {
            startDate: '2023-11-26',
            endDate: '2024-10-27',
            warehouseOwner: 'All',
            deliveryStatus: {
              code: 'P',
              description: 'Pending',
            },
          },
        },
        {
          label: '15 days pending',
          noOfDr: 20,
          filters: {
            startDate: '2023-11-26',
            endDate: '2024-10-27',
            warehouseOwner: 'All',
            deliveryStatus: {
              code: 'P',
              description: 'Pending',
            },
          },
        },
        {
          label: '30 days pending',
          noOfDr: 0,
          filters: {
            startDate: '2024-10-28',
            endDate: '2024-10-28',
          },
        },
        {
          label: 'More than 30 days pending',
          noOfDr: 2,
          filters: {
            startDate: '2023-11-26',
            endDate: '2024-10-27',
          },
        },
      ],
    },
    {
      summaryTitle: 'Dispatch To Warehouse Deliveries',
      summaryCountTitle: 'No. of DRs',
      url: 'wms-report-in-transit',
      isViewable: 1,
      isConsolidated: true,
      icon: 'warehouse',
      items: [
        {
          label: 'EDA is Today',
          noOfDr: 20,
          filters: {
            startDate: '2023-11-26',
            endDate: '2024-10-27',
            warehouseOwner: 'All',
            deliveryStatus: {
              code: 'P',
              description: 'Pending',
            },
          },
        },
        {
          label: '15 days pending',
          noOfDr: 20,
          filters: {
            startDate: '2023-11-26',
            endDate: '2024-10-27',
            warehouseOwner: 'All',
            deliveryStatus: {
              code: 'P',
              description: 'Pending',
            },
          },
        },
        {
          label: '30 days pending',
          noOfDr: 0,
          filters: {
            startDate: '2024-10-28',
            endDate: '2024-10-28',
          },
        },
        {
          label: 'More than 30 days pending',
          noOfDr: 2,
          filters: {
            startDate: '2023-11-26',
            endDate: '2024-10-27',
          },
        },
      ],
    },
    {
      summaryTitle: 'Rejected Warehouse Transfer Deliveries',
      summaryCountTitle: 'No. of DRs',
      url: 'wms-report-in-transit',
      isViewable: 1,
      isConsolidated: true,
      icon: 'production_quantity_limits',
      items: [
        {
          label: 'More than 30 Days Pending',
          noOfDr: 6,
          filters: {
            startDate: '2023-11-26',
            endDate: '2024-10-27',
            transactionType: 'REJECTED_WAREHOUSE_TRANSFER',
            movementType: 'INBOUND',
            agingDays: '0',
            warehouseOwner: 'All',
          },
        },
        // {
        //   label: '30 Days Pending',
        //   noOfDr: 0,
        //   filters: {
        //     startDate: '2024-10-28',
        //     endDate: '2024-10-28',
        //   },
        // },
        // {
        //   label: 'More than 30 Days Pending',
        //   noOfDr: 2,
        //   filters: {
        //     startDate: '2023-11-26',
        //     endDate: '2024-10-27',
        //   },
        // },
      ],
    },
    {
      summaryTitle: 'Return Out Deliveries',
      summaryCountTitle: 'No. of DRs',
      url: 'wms-report-receiving-return-out',
      isViewable: 1,
      isConsolidated: true,
      icon: 'assignment_return',
      items: [
        {
          label: '15 Days Pending',
          noOfDr: 0,
          filters: {
            startDate: '2024-11-12',
            endDate: '2024-11-12',
          },
        },
        // {
        //   label: '30 Days Pending',
        //   noOfDr: 0,
        //   filters: {
        //     startDate: '2024-10-28',
        //     endDate: '2024-10-28',
        //   },
        // },
        // {
        //   label: 'More than 30 Days Pending',
        //   noOfDr: 2,
        //   filters: {
        //     startDate: '2023-11-26',
        //     endDate: '2024-10-27',
        //   },
        // },
      ],
    },
  ];
}

const BASE_ELEMENT_ID: string = 'id_notification_drawer';
export const ELEMENT_IDS: { [key: string]: string } = {
  'cnt':            BASE_ELEMENT_ID + '_cnt',
  'cnt_header':     BASE_ELEMENT_ID + '_cnt_header',
  'btn_close':      BASE_ELEMENT_ID + '_btn_close',
  'lbl_title':      BASE_ELEMENT_ID + '_lbl_title',
  'cnt_summary':    BASE_ELEMENT_ID + '_cnt_summary',
  'btn_view':       BASE_ELEMENT_ID + '_btn_view',
};
